export const apiEndPoints = {
    PAGE_DATA: 'get-req-data/page-data',
    SECTIONS: 'get-req-data/sections',
    MEDIA: 'get-req-data/media-by-cats',
    PRODUCTS: 'get-req-data/product-by-cats',
    FORM_SUBMIT: 'post-req-data/form-submit',
    POSTS: 'get-req-data/posts',
    PRODUCTS_DATA: 'get-req-data/product-data',
};
